export default __webpack_public_path__ + "107f10a9096639bf7fb0c6c3a76b5f2a.png";